<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="ma-0 pa-0">
        <v-card class="elevation-0 transparent">
          <v-card-text >

            <div class="black--text text-h6">
              Total de horas:         {{ totalHoras }}
            </div>
            <br/>
            <v-row>

              <v-btn
              color="orange"
              dark
              class="mr-2"
              @click="subirRequisicion( )"
              outlined
              >
              Subir requisición
              <v-icon right small >mdi-lock</v-icon>
            </v-btn>

            <v-btn
            color="primary"
            dark
            @click="actualizarNomina()"
            outlined
            class="mr-2"
            >
            Actualizar
          </v-btn>

            <v-btn
              color="teal darken-1"
              dark
              class="mr-2"
              @click="verDesgloseGuardado()"
              outlined
              :disabled="!ciclo"
            >
              Desglose guardado
              <v-icon right small>mdi-history</v-icon>
            </v-btn>

            <v-btn
              color="red darken-1"
              class="mr-2"
              outlined
              :disabled="!ciclo"
              @click="abrirHuellas( 1 )"
            >
              Sin huella sabatino ({{ faltasHuellaSab.length }})
              <v-icon right small>{{ revisadoHuellaSab ? 'mdi-check-circle' : 'mdi-fingerprint-off' }}</v-icon>
            </v-btn>

            <v-btn
              v-if="quincenaHuellaActiva"
              color="red darken-1"
              class="mr-2"
              outlined
              :disabled="!ciclo"
              @click="abrirHuellas( 2 )"
            >
              Sin huella quincena ({{ faltasHuellaQuin.length }})
              <v-icon right small>{{ revisadoHuellaQuin ? 'mdi-check-circle' : 'mdi-fingerprint-off' }}</v-icon>
            </v-btn>
          <v-spacer></v-spacer>
          <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
            <v-text-field
            v-model="search"
            dense
            filled
            single-line
            label="Buscar"
            append-icon="mdi-magnify"
            ></v-text-field>  
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" class="black--text">
            <b>% aceptación Quincena:</b> {{ porcentajeAceptacionQ }} --- ST {{ dominicalSem + lvSem }}
            <br/>
            <b>% aceptación Bono:</b> {{ porcentajeAceptacionB }}
            <br/>
            <b>% aceptación Sabatina:</b> {{ porcentajeAceptacionA }} --- ST {{ sabatinoSem }}
          </v-col>

          <v-col cols="12" class="black--text">
            <b>TEACHERS APOYO LVD:</b> {{ (Number(lvSemT) || 0) + (Number(dominicalSemT) || 0) }}
            <br/>
            <b>TEACHERS APOYO SABATINO:</b> {{ Number(sabatinoSemT) || 0 }} 
          </v-col>
        </v-row>

        <v-row v-if="!liberar">
          <v-col cols="12" class="black--text">
            <label>Maestros sin categoria</label>
            <span v-for="( ma , i ) in maestros" :key="i" class="black--text"> {{ ma }}<br/></span>
          </v-col>
        </v-row>

        <v-row v-if="!liberar">
          <v-col cols="12" class="black--text">
            <v-alert
            dense
            outlined
            type="error"
            >
            Agrega la categoría a los maestros para poder liberar la nómina
          </v-alert>
        </v-col>
      </v-row>

      <v-row v-if="huellasPendientesRevision || errorExcepcionesHuella">
        <v-col cols="12" class="black--text">
          <v-alert
            v-if="huellasPendientesRevision"
            dense
            outlined
            type="error"
          >
            Revisa los teachers sin huella
            <span v-if="huellaSabPendiente">(sabatino)</span>
            <span v-if="huellaQuinPendiente">(quincena)</span>
            antes de subir la requisición
          </v-alert>
          <v-alert
            v-if="errorExcepcionesHuella"
            dense
            outlined
            type="warning"
          >
            {{ errorExcepcionesHuella }}. Los descuentos se aplicaron sin excepciones.
          </v-alert>
        </v-col>
      </v-row>

      <v-tabs
        v-model="tab"
        align-with-title
      >
        <v-tabs-slider></v-tabs-slider>

        <!-- <v-tab v-if="liberar">Nómina</v-tab>
        <v-tab v-if="liberar">Disp. Horas Sab</v-tab>
        <v-tab v-if="[1,3].includes( selectedHeaders ) && liberar">Disp. Horas Quin</v-tab>
        <v-tab v-if="liberar">Comparativa Sab</v-tab>
        <v-tab v-if="[1,3].includes( selectedHeaders ) && liberar">Comparativa Quin</v-tab>
        <v-tab v-if="[1].includes( selectedHeaders ) && liberar">Comparativa Bonos</v-tab> -->

        <v-tab >Nómina</v-tab>
        <v-tab >Disp. Horas Sab</v-tab>
        <v-tab v-if="[1,3].includes( selectedHeaders )">Disp. Horas Quin</v-tab>
        <v-tab >Comparativa Sab</v-tab>
        <v-tab v-if="[1,3].includes( selectedHeaders )">Comparativa Quin</v-tab>
        <v-tab v-if="[1].includes( selectedHeaders )">Comparativa Bonos</v-tab>
      </v-tabs>

    <v-tabs-items v-model="tab">

      <!-- Nómina -->
      <v-tab-item>
        <v-card flat>
          <v-card-text>

            <v-radio-group
              v-model="opcionFiltro"
              row
              dense
            >
            <v-radio
            label="Pendiente"
            :value="0"
            ></v-radio>
            <v-radio
            label="Aceptados"
            :value="1"
            ></v-radio>
            <v-radio
            label="Rechazados"
            :value="2"
            ></v-radio>
            <v-radio
            label="Todos"
            :value="3"
            ></v-radio>

            <v-radio
            label="Sin categoría"
            :value="4"
            ></v-radio>

          </v-radio-group>

          <v-spacer></v-spacer>
          <v-btn 
            class="mr-2" 
            small 
            dark 
            color="green"
            tile
            @click="exportar()"
          >
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>

        <v-data-table
          :headers="headersNominaHuella"
          :items="filterTeachers"
          class="elevation-0"
          dense
          :search="search"
        >
        <template v-slot:item.aceptado="{ item }">
          <v-chip v-if="(!item.aceptado)    " small color="grey"  dark >Pendiente</v-chip>
          <v-chip v-if="(item.aceptado == 1)" small color="green" dark >Aceptada</v-chip>
          <v-chip v-if="(item.aceptado == 2)" small color="red"   dark >Rechazada</v-chip>
        </template>

        <template v-slot:item.hsbc="{ item }">
          <v-chip v-if="(item.hsbc == 1)" small color="green" dark >Si</v-chip>
          <v-chip v-if="(item.hsbc == 2)" small color="red"   dark >No</v-chip>
        </template>

        <template v-slot:item.pago_quincena="{ item }">
          <v-chip 
          v-if="item.estatus_quincena" 
          :color="item.estatus_quincena == 1 ? 'green' : 'red'" 
          dark
          small 
          @click="verComentarios( item.comentarios_quincena, 2 , item )"
          >
          {{ item.pago_quincena }}
        </v-chip>

        <v-chip v-else color="grey" small dark @click="verComentarios( item.comentarios_quincena, 2 , item )">{{ item.pago_quincena }}</v-chip>
      </template>

      <template v-slot:item.PAGO_SABADO="{ item }">
        <v-chip 
        v-if="item.estatus_sabatina" 
        :color="item.estatus_sabatina == 1 ? 'green' : 'red'" 
        dark
        small 
        @click="verComentarios( item.comentarios_sabatina, 1 , item )"
        >
        {{ item.PAGO_SABADO }}
      </v-chip>

      <v-chip v-else color="grey" small dark @click="verComentarios( item.comentarios_sabatina, 1 , item )">{{ item.PAGO_SABADO }}</v-chip>
    </template>

    <template v-slot:item.bono_teacher="{ item }">
      <v-chip 
      v-if="item.estatus_bono" 
      :color="item.estatus_bono == 1 ? 'green' : 'red'" 
      dark
      small 
      @click="verComentarios( item.comentarios_bono, 3 , item )"
      >
      {{ item.bono_teacher }}
    </v-chip>

    <v-chip v-else color="grey" small dark @click="verComentarios( item.comentarios_bono, 3 , item )">{{ item.bono_teacher }}</v-chip>
  </template>

</v-data-table>
</v-card-text>
</v-card>
</v-tab-item>

<!-- Disperción de horas del sabatino -->
<v-tab-item>
  <v-card flat>
    <v-card-text>
      <v-data-table
      :headers="headers2"
      :items="teachers"
      class="elevation-0"
      dense
      :search="search"
      >
    </v-data-table>
  </v-card-text>
</v-card>
</v-tab-item>

<!-- Disperción de horas del Quincena -->
<v-tab-item v-if="[1,3].includes( selectedHeaders )">
  <v-card flat>
    <v-card-text>
      <v-data-table
      :headers="headers2Q"
      :items="teachersQ"
      class="elevation-0"
      dense
      :search="search"
      >
    </v-data-table>
  </v-card-text>
</v-card>
</v-tab-item>

<!-- Comparativa del Sabatina -->
<v-tab-item>
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="5">
          <label class="black--text"><b>Semana {{ selectedHeaders - 1 }}</b></label>
          <v-chip
            x-small
            color="teal lighten-4"
            class="ml-2"
            :title="usandoHistorialSab ? 'Datos del historial guardado al subir requisición' : 'Calculado al momento (sin historial)'"
          >
            {{ usandoHistorialSab ? 'historial' : 'cálculo' }}
          </v-chip>
          <v-alert
            v-if="!usandoHistorialSab && sinHistorialComparativaSab"
            dense
            outlined
            type="info"
            class="mt-2 mb-2"
          >
            No hay historial guardado de la semana anterior. Se muestra el cálculo en vivo.
          </v-alert>
          <v-data-table
          :headers="headers3"
          :items="tabla2Comparativa"
          class="elevation-0"
          dense
          :search="search"
          >
        </v-data-table>
        <label class="text-h6"><b>Costo por hora: {{ costoHora1 }}</b></label>
        </v-col>

      <v-col cols="12" md="7">

        <label class="black--text"><b>Semana {{ selectedHeaders }}</b></label>
        <v-chip x-small color="blue lighten-4" class="ml-2" title="Calculado al momento con el rol de clases actual">cálculo</v-chip>
        <v-data-table
        :headers="headers4"
        :items="tabla1Comparativa"
        class="elevation-0"
        dense
        :search="search"
        >
      </v-data-table>
      <label class="text-h6"><b>Costo por hora: {{ costoHora2 }}</b></label>
  </v-col>

  <v-col cols="12">
    <div class="text-subtitle-1 font-weight-bold mb-1">Horas por grupo</div>
    <v-data-table
      :headers="headersHorasGruposSab"
      :items="filasHorasGruposSab"
      item-key="clave"
      dense
      :items-per-page="10"
      class="elevation-0"
      :item-class="claseFilaHorasGrupo"
      no-data-text="Ningún grupo cambió de horas"
    >
      <template v-slot:item.diferencia="{ item }">
        <b :class="item.diferencia > 0 ? 'green--text text--darken-2' : 'red--text text--darken-2'">
          {{ formatoHorasCambio(item.diferencia) }}
        </b>
      </template>
      <template v-slot:body.append>
        <tr class="font-weight-bold">
          <td>Total</td>
          <td class="text-right">{{ totalHorasAnteriorSab }}</td>
          <td class="text-right">{{ totalHorasActualSab }}</td>
          <td class="text-right">
            <span :class="totalHorasGruposSab > 0 ? 'green--text text--darken-2' : (totalHorasGruposSab < 0 ? 'red--text text--darken-2' : '')">
              {{ formatoHorasCambio(totalHorasGruposSab) }}
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-col>
</v-row>
</v-card-text>
</v-card>
</v-tab-item>

<!-- Comparativa de la quincena -->
<v-tab-item v-if="[1,3].includes( selectedHeaders )">
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="5">
          <label class="black--text"><b>Quincena {{ 1 }}</b></label>
          <v-chip x-small color="teal lighten-4" class="ml-2" title="Calculado del ciclo anterior">cálculo</v-chip>
          <v-data-table
          :headers="headers3"
          :items="tabla2ComparativaQ"
          class="elevation-0"
          dense
          :search="search"
          >
        </v-data-table>
        <label class="text-h6"><b>Costo por hora: {{ costoHora1 }}</b></label>
        </v-col>

      <v-col cols="12" md="7">

        <label class="black--text"><b>Quincena {{ 2 }}</b></label>
        <v-data-table
        :headers="headers4"
        :items="tabla1ComparativaQ"
        class="elevation-0"
        dense
        :search="search"
        >
      </v-data-table>
      <label class="text-h6"><b>Costo por hora: {{ costoHora2 }}</b></label>

      <div class="mt-3 mb-2">
        <v-simple-table dense class="elevation-0" style="max-width: 360px;">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"></th>
                <th class="text-right">INBI</th>
                <th class="text-right">FAST</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Grupos Dominicales</td>
                <td class="text-right">{{ desgloseNotasQuincena.inbi.dominicales }}</td>
                <td class="text-right">{{ desgloseNotasQuincena.fast.dominicales }}</td>
              </tr>
              <tr>
                <td>Grupos entre semana</td>
                <td class="text-right">{{ desgloseNotasQuincena.inbi.entreSemana }}</td>
                <td class="text-right">{{ desgloseNotasQuincena.fast.entreSemana }}</td>
              </tr>
              <tr>
                <td><b>Total de grupos</b></td>
                <td class="text-right"><b>{{ desgloseNotasQuincena.inbi.dominicales + desgloseNotasQuincena.inbi.entreSemana }}</b></td>
                <td class="text-right"><b>{{ desgloseNotasQuincena.fast.dominicales + desgloseNotasQuincena.fast.entreSemana }}</b></td>
              </tr>
              <tr>
                <td>Grupos cambiados</td>
                <td class="text-right">{{ desgloseNotasQuincena.inbi.cambiados }}</td>
                <td class="text-right">{{ desgloseNotasQuincena.fast.cambiados }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
  </v-col>

  <v-col cols="12">
    <div class="text-subtitle-1 font-weight-bold mb-1">Horas por grupo</div>
    <v-data-table
      :headers="headersHorasGruposQ"
      :items="filasHorasGruposQ"
      item-key="clave"
      dense
      :items-per-page="10"
      class="elevation-0"
      :item-class="claseFilaHorasGrupo"
      no-data-text="Ningún grupo cambió de horas"
    >
      <template v-slot:item.diferencia="{ item }">
        <b :class="item.diferencia > 0 ? 'green--text text--darken-2' : 'red--text text--darken-2'">
          {{ formatoHorasCambio(item.diferencia) }}
        </b>
      </template>
      <template v-slot:body.append>
        <tr class="font-weight-bold">
          <td>Total</td>
          <td class="text-right">{{ totalHorasAnteriorQ }}</td>
          <td class="text-right">{{ totalHorasActualQ }}</td>
          <td class="text-right">
            <span :class="totalHorasGruposQ > 0 ? 'green--text text--darken-2' : (totalHorasGruposQ < 0 ? 'red--text text--darken-2' : '')">
              {{ formatoHorasCambio(totalHorasGruposQ) }}
            </span>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-col>
</v-row>
</v-card-text>
</v-card>
</v-tab-item>

<!-- Comparativa de bonos -->
<v-tab-item v-if="[1].includes( selectedHeaders )">
  <v-card flat>
    <v-card-text>
      <v-row>
        <v-col cols="12" v-if="bonosHistorialActual.length" class="pb-0">
          <v-alert dense text type="info" class="mb-2">
            Comparativa alineada al historial de requi (total máximo guardado de la semana).
          </v-alert>
        </v-col>
        <v-col cols="12">
          <v-data-table
          :headers="headersBono"
          :items="tablaBonos"
          class="elevation-0"
          dense
          :search="search"
          >
        </v-data-table>
      </v-col>
    </v-row>
  </v-card-text>
</v-card>
</v-tab-item>
</v-tabs-items>

</v-card-text>
</v-card> 
</v-col>
</v-row>

<v-dialog
v-model="dialogVerComentario"
max-width="500px"
v-if="comentarios"
>
<v-card>
  <v-card-title primary-title>
    Comentarios de nómina
  </v-card-title>
  <v-card-actions>
    <v-row>
      <v-col cols="12"
      v-for="(mensaje, i) in comentarios" :key="i"
      >
      <p 
      :class="`pa-2 ma-0 mb-4 ${ mensaje.id_usuario != getdatosUsuarioERPERP.iderp ? 'mensajeIzq' : 'mensajeDer' }`">
      {{ mensaje.comentarios }}
      <br/>
      {{ mensaje.nombre_completo }}
    </p>
  </v-col>
</v-row>
<br/>
</v-card-actions>
<v-card-text>
  <v-textarea
  v-model="respuesta"
  filled
  :rows="3"
  auto-grow
  label="respuesta al colaborador"
  ></v-textarea>
  <v-btn 
  color="success"
  @click="responder( )"
  tile
  >
  responder
</v-btn>
</v-card-text>
</v-card> 

</v-dialog>

<v-dialog
  v-model="dialogPagar"
  max-width="440px"
  persistent
>
  <v-card class="shadowCard" rounded="lg">
    <div class="text-center pt-6">
      <v-avatar color="orange lighten-5" size="72">
        <v-icon color="orange darken-2" size="40">mdi-file-document-check-outline</v-icon>
      </v-avatar>
    </div>

    <v-card-title class="justify-center text-h6 font-weight-bold pb-1">
      Confirmar requisición
    </v-card-title>

    <v-card-text class="text-center grey--text text--darken-1 px-8">
      Se generará la requisición de nómina de teachers y se guardará el desglose de la semana
      <strong> {{ selectedHeaders }}</strong>. ¿Deseas continuar?
    </v-card-text>

    <v-card-actions class="px-6 pb-6">
      <v-btn
        text
        color="grey darken-1"
        @click="dialogPagar = false"
        :disabled="cargar"
      >
        Cancelar
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="orange darken-2"
        dark
        depressed
        rounded
        :loading="cargar"
        @click="pagar( )"
      >
        <v-icon left small>mdi-lock</v-icon>
        Sí, generar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Dialog Requis -->
<v-dialog
v-model="dialogRequis"
max-width="1200px"
>
<v-card>
  <v-card-title primary-title>
    Datos de la requisición
  </v-card-title>
  <v-card-text>

    <v-row>
      <!-- Seleccionar la requisición -->
      <v-col>
        <v-radio-group
        v-model="opEscuela"
        row
        >
        <v-radio
        label="Inbi"
        :value="1"
        ></v-radio>
        <v-radio
        label="Fast"
        :value="2"
        ></v-radio>
      </v-radio-group>
    </v-col>

    <!-- Seleccionar el tipo de requisición -->
    <v-col>
      <v-radio-group
      v-model="opRquisicion"
      row
      >
      <v-radio
      label="Sabatina"
      :value="1"
      ></v-radio>
      <v-radio
      label="Quincena"
      :value="2"
      ></v-radio>
      <v-radio
      label="Bono"
      :value="3"
      ></v-radio>
    </v-radio-group>
  </v-col>
</v-row>

<v-row>
  <v-col cols="12" v-if="opRquisicion == 1 && opEscuela == 1">
    <v-data-table
    :headers="headerRequi"
    :items="requisTeacherInbiS"
    class="elevation-0"
    dense
    >
    <template v-slot:item.costo_unitario="{ item }">
      <span>{{ format( item.costo_unitario ) }}</span>
    </template>

    <template v-slot:item.costo_total="{ item }">
      <span>{{ format( item.costo_total ) }}</span>
    </template>

  </v-data-table>
</v-col>

<v-col cols="12" v-if="opRquisicion == 1 && opEscuela == 2">
  <v-data-table
  :headers="headerRequi"
  :items="requisTeacherFastS"
  class="elevation-0"
  dense
  >
  <template v-slot:item.costo_unitario="{ item }">
    <span>{{ format( item.costo_unitario ) }}</span>
  </template>

  <template v-slot:item.costo_total="{ item }">
    <span>{{ format( item.costo_total ) }}</span>
  </template>

</v-data-table>
</v-col>

<v-col cols="12" v-if="opRquisicion == 3 && opEscuela == 1">
  <v-data-table
  :headers="headerRequi"
  :items="detallesBonoInbi"
  class="elevation-0"
  dense
  >
  <template v-slot:item.costo_unitario="{ item }">
    <span>{{ format( item.costo_unitario ) }}</span>
  </template>

  <template v-slot:item.costo_total="{ item }">
    <span>{{ format( item.costo_total ) }}</span>
  </template>

</v-data-table>
</v-col>


<v-col cols="12" v-if="opRquisicion == 2 && opEscuela == 1">
  <v-data-table
  :headers="headerRequi"
  :items="requisTeacherInbiQ"
  class="elevation-0"
  dense
  >
  <template v-slot:item.costo_unitario="{ item }">
    <span>{{ format( item.costo_unitario ) }}</span>
  </template>

  <template v-slot:item.costo_total="{ item }">
    <span>{{ format( item.costo_total ) }}</span>
  </template>

</v-data-table>
</v-col>

<v-col cols="12" v-if="opRquisicion == 2 && opEscuela == 2">
  <v-data-table
  :headers="headerRequi"
  :items="requisTeacherFastQ"
  class="elevation-0"
  dense
  >
  <template v-slot:item.costo_unitario="{ item }">
    <span>{{ format( item.costo_unitario ) }}</span>
  </template>

  <template v-slot:item.costo_total="{ item }">
    <span>{{ format( item.costo_total ) }}</span>
  </template>

</v-data-table>
</v-col>

<v-col cols="12" v-if="opRquisicion == 3 && opEscuela == 2">
  <v-data-table
  :headers="headerRequi"
  :items="detallesBonoFast"
  class="elevation-0"
  dense
  >
  <template v-slot:item.costo_unitario="{ item }">
    <span>{{ format( item.costo_unitario ) }}</span>
  </template>

  <template v-slot:item.costo_total="{ item }">
    <span>{{ format( item.costo_total ) }}</span>
  </template>

</v-data-table>
</v-col>

</v-row>

</v-card-text>
<v-card-actions>
  <v-btn 
  color="success"
  @click="dialogPagar = true"
  outlined
  >
  Subir Requi
</v-btn>
</v-card-actions>
</v-card> 

</v-dialog>

<v-dialog
  v-model="dialogDesglose"
  max-width="1400px"
  scrollable
>
  <v-card>
    <v-card-title class="subtitle-1 font-weight-bold">
      Desglose guardado — Semana {{ selectedHeaders }}
      <v-spacer></v-spacer>
      <v-btn icon small @click="dialogDesglose = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-alert
        v-if="!desgloseHistorial.length && !cargar"
        type="info"
        dense
        outlined
      >
        No hay desglose guardado para esta semana. Se registra al subir la requisición.
      </v-alert>
      <template v-else>
        <v-row class="mb-2">
          <v-col cols="12" sm="6" md="5">
            <v-text-field
              v-model="searchDesglose"
              dense
              filled
              hide-details
              label="Buscar"
              append-icon="mdi-magnify"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="7" class="text-right">
            <v-btn
              small
              dark
              color="green"
              tile
              :disabled="!desgloseHistorial.length"
              @click="exportarDesgloseHistorial()"
            >
              <v-icon>mdi-microsoft-excel</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headersNomina"
          :items="desgloseHistorial"
          :search="searchDesglose"
          class="elevation-0"
          dense
          item-key="id_teacher"
        ></v-data-table>
      </template>
    </v-card-text>
  </v-card>
</v-dialog>

<!-- Teachers sin huella -->
<v-dialog
  v-model="dialogHuellas"
  max-width="1300px"
  scrollable
>
  <v-card>
    <v-card-title class="subtitle-1 font-weight-bold">
      Sin huella — {{ tipoHuellas == 2 ? 'Quincena' : 'Sabatino' }}
      <v-spacer></v-spacer>
      <v-btn icon small @click="dialogHuellas = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-alert dense outlined type="info" class="mb-2">
        Días con clase presencial en los que el teacher no registró ninguna checada. No se pagan las horas de ese día salvo que se registre una excepción. Los grupos ONLINE no se validan.
      </v-alert>

      <v-row class="mb-2">
        <v-col cols="12" sm="6" md="5">
          <v-text-field
            v-model="searchHuellas"
            dense
            filled
            hide-details
            label="Buscar"
            append-icon="mdi-magnify"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="6" md="7" class="text-right black--text">
          <b>Total a descontar:</b> {{ format( totalDescuentoHuellaVista ) }}
        </v-col>
      </v-row>

      <v-data-table
        :headers="headersHuellas"
        :items="faltasHuellaVista"
        :search="searchHuellas"
        class="elevation-0"
        dense
        item-key="clave"
      >
        <template v-slot:item.fecha="{ item }">
          {{ formatoFechaHuella( item.fecha ) }}
        </template>

        <template v-slot:item.monto="{ item }">
          <span :class="item.excepcion ? 'text-decoration-line-through grey--text' : 'red--text'">
            {{ format( item.monto ) }}
          </span>
        </template>

        <template v-slot:item.excepcion="{ item }">
          <v-chip v-if="!item.excepcion" small color="red" dark>Se descuenta</v-chip>
          <div v-else>
            <v-chip small color="green" dark>Justificado</v-chip>
            <div class="caption">
              {{ item.excepcion.motivo }}
              <span v-if="item.excepcion.usuario_autoriza"> — {{ item.excepcion.usuario_autoriza }}</span>
            </div>
          </div>
        </template>

        <template v-slot:item.acciones="{ item }">
          <v-btn
            v-if="!item.excepcion"
            small
            rounded
            outlined
            color="green"
            @click="abrirExcepcionHuella( item )"
          >
            Justificar
          </v-btn>
          <v-btn
            v-else
            small
            rounded
            outlined
            color="red"
            @click="eliminarExcepcionHuella( item )"
          >
            Quitar excepción
          </v-btn>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="black"
        dark
        small
        rounded
        @click="dialogHuellas = false"
      >
        Cerrar
      </v-btn>
      <v-btn
        color="green"
        dark
        small
        rounded
        @click="marcarHuellasRevisadas( )"
      >
        <v-icon left small>mdi-check</v-icon>
        Marcar como revisado
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Justificar día sin huella -->
<v-dialog
  v-model="dialogExcepcionHuella"
  max-width="500px"
>
  <v-card v-if="faltaHuellaSeleccionada">
    <v-card-title class="subtitle-1 font-weight-bold">
      Justificar día sin huella
    </v-card-title>
    <v-card-text class="black--text">
      <div><b>Teacher:</b> {{ faltaHuellaSeleccionada.teacher }}</div>
      <div><b>Fecha:</b> {{ formatoFechaHuella( faltaHuellaSeleccionada.fecha ) }}</div>
      <div class="mb-3"><b>Monto:</b> {{ format( faltaHuellaSeleccionada.monto ) }}</div>
      <v-textarea
        v-model="motivoExcepcionHuella"
        filled
        dense
        rows="3"
        label="Motivo (obligatorio)"
        counter="500"
        maxlength="500"
      ></v-textarea>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="black"
        dark
        small
        rounded
        @click="dialogExcepcionHuella = false"
      >
        Cancelar
      </v-btn>
      <v-btn
        color="green"
        dark
        small
        rounded
        :loading="cargar"
        @click="guardarExcepcionHuella( )"
      >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

<!-- Dialog de carga -->
<Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
<carga                v-if="cargar"/>

</v-container>
</template>

<script>
  import axios from 'axios';
  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores       from '@/mixins/validarErrores'
  import XLSX                 from 'xlsx'
  import funcionesExcel       from '@/mixins/funcionesExcel'
  import mixinNominaSabatina  from '@/mixins/mixinNominaSabatina'
  import mixinNominaQuincena  from '@/mixins/mixinNominaQuincena'
  import mixinNominaHuellas   from '@/mixins/mixinNominaHuellas'
  import { mapDetalleHistorialRows } from '@/utils/nominaTeachersHistorial'

  export default {
    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel, mixinNominaSabatina, mixinNominaQuincena, mixinNominaHuellas ],

    props:[
      'selectedHeaders',
      'ciclo',
    ],

    data: () => ({
    // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      opcionFiltro: 3,

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      teacherActivos:[],

      teachersBonos: [],

      teachers:[],
      teachersQ:[],

      headersNomina: [
        { text: 'id'                , value: 'id_teacher'           },
        { text: 'Teacher'           , value: 'teacher'              },  
        { text: 'Categoría'         , value: 'aceptado'             },  
        { text: 'HSBC'              , value: 'hsbc'                 },  
        { text: 'Plantel'           , value: 'plantel'              },  
        { text: 'existeCategoria'   , value: 'existeCategoria'      },  
        { text: 'PAGOS_DOBLES_SABADO'       , value: 'PAGO_SABADO', align: 'end'},  
      ],

      headers3: [
        { text: 'valor hora' , value: 'valor_hora'    },
        { text: '# horas'    , value: 'numero_horas'  },  
        { text: 'Costo'      , value: 'costo'         },  
      ],

      headers2: [
        { text: 'id'              ,  value: 'id_teacher'         },
        { text: 'Teacher'         ,  value: 'teacher'            },  
        { text: 'H_SABADO_FAST'   ,  value: 'HORAS_SABADO_FAST'  },  
        { text: 'H_SABADO_INBI'   ,  value: 'HORAS_SABADO_INBI'  },  
        { text: 'H_SABADO_TEENS'  ,  value: 'HORAS_SABADO_TEENS' },  
        { text: 'TOTAL_HORAS'     ,  value: 'TOTAL_HORAS'        },  
        { text: 'Costo H'         ,  value: 'categoria'          },  
        { text: 'PAGO_SABADO'     ,  value: 'PAGO_SABADO'        },  
        // { text: 'PAGO_DOBLES_SABADO'     ,  value: 'PAGO_DOBLES_SABADO'        },  
      ],

      headers4: [
        { text: 'valor hora' , value: 'valor_hora'    },
        { text: '# horas'    , value: 'numero_horas'  },  
        { text: 'Costo'      , value: 'costo'         },  
        { text: 'Diferencia' , value: 'diferencia'    },  
        { text: 'Motivo'     , value: 'motivo'        },  
      ],

      headers2Q: [
        { text: 'id'              ,  value: 'id_teacher'               },
        { text: 'Teacher'         ,  value: 'teacher'                  },  
        { text: 'H_LV_FAST'       ,  value: 'HORAS_ENTRE_SEMANA_FAST'  },  
        { text: 'H_D_FAST'        ,  value: 'HORAS_DOMINGO_FAST'       },  
        { text: 'H_ONL_TEENS'     ,  value: 'HORAS_LMV_FAST'           },  
        { text: 'H_LV_INBI'       ,  value: 'HORAS_ENTRE_SEMANA_INBI'  },  
        { text: 'H_D_INBI'        ,  value: 'HORAS_DOMINGO_INBI'       },  
        { text: 'H_ONL_TEENS'     ,  value: 'HORAS_LMV_INBI'           },
        { text: 'TOTAL_HORAS'     ,  value: 'HORAS_TOTALES'            },  
        { text: 'Costo H LV'      ,  value: 'categoria_lv'             }, 
        { text: 'Costo H D'       ,  value: 'categoria_d'              }, 
        { text: 'PAGO_TOTAL'      ,  value: 'PAGO_TOTAL'               },  
      ],

      headersBono: [
        { text: 'id'              , value: 'id_teacher'   },
        { text: 'Teacher'         , value: 'teacher'      },
        { text: 'PAGO Anterior'   , value: 'bono_anterior', align: 'end' } ,
        { text: 'PAGO BONO'       , value: 'bono_teacher', align: 'end' },  
        { text: 'diferencia'      , value: 'diferencia', align: 'end' }  
      ],

      headerRequi: [
        { text: 'ID Empleado'   , value: 'id_empleado'     },
        { text: 'Concepto'      , value: 'concepto'        },
        { text: 'Plantel'       , value: 'plantel'         },
        { text: 'Elemento'      , value: 'elemento'        , align: 'end' },
        { text: 'Costo U.'      , value: 'costo_unitario'  , align: 'end' },
        { text: 'Costo T'       , value: 'costo_total'     , align: 'end' },
      ],

      search:'',
      gruposActivos:[],

      tab: null,

      tabla1Comparativa: [],
      tabla2Comparativa: [],

      tabla1ComparativaQ: [],
      tabla2ComparativaQ: [],

      categorias1:[],
      categorias2:[],
      categorias1Q:[],
      categorias2Q:[],


      costoHora1: 0,
      costoHora2: 0,
      horasImpartidas: 0,
      horasImpartidasAnt: 0,

      costoHora1Q: 0,
      costoHora2Q: 0,
      horasImpartidasQ: 0,
      horasImpartidasAntQ: 0,

      gruposQuincena: [],
      gruposCicloActual: [],
      mapaConsecutivos: {},
      cicloAnt: null,
      comentariosT:[],
      dialogVerComentario: false,
      comentarios:[],
      porcentajeAceptacionQ:0,
      porcentajeAceptacionB:0,
      respuesta:'',
      gruposQuincenaAnt:[],

      gruposAllBono:[],
      tipo_nomina: 0,
      renglonNomina: null,
      rebajes: [],
      bonosTeachers:[],
      bonosAnterioresHistorial: [],
      bonosHistorialActual: [],
      sinHistorialComparativaSab: false,
      sinHistorialComparativaQuin: false,
      usandoHistorialSab: false,
      notasSabatinoHistorial: '',

      liberar: false,
      maestros: [],
      dialogPagar: false,
      dialogRequis: false,
      dialogDesglose: false,
      desgloseHistorial: [],
      searchDesglose: '',
      requisTeacherInbiS:[],
      requisTeacherInbiQ:[],
      requisTeacherFastS:[],
      requisTeacherFastQ:[],
      detallesBonoInbi:[],
      detallesBonoFast:[],
      opEscuela: 1,
      opRquisicion: 1,

      sabatinoSem: 0,
      dominicalSem: 0,
      lvSem: 0,
      sabatinoSemT: 0,
      dominicalSemT: 0,
      lvSemT: 0,
      horasDoblesSabatino: [],
    }),

computed: {

  ...mapGetters( 'login' ,['getdatosUsuarioERPERP']),

  porcentajeAceptacionA( ){
    return this.calcPorcentajeAceptacion(this.teachers, 'estatus_sabatina')
  },

  headersNominaHuella( ){
    const headers = this.headersNomina.slice()
    headers.push({ text: 'DESC. HUELLA SAB', value: 'DESC_HUELLA_SAB', align: 'end' })
    if( this.quincenaHuellaActiva ){
      headers.push({ text: 'DESC. HUELLA QUIN', value: 'DESC_HUELLA_QUIN', align: 'end' })
    }
    return headers
  },

  filterTeachers( ){

    console.log( 'BONO TEACHERS', this.bonosTeachers )

    try{

      if( this.selectedHeaders == 1 && this.bonosTeachers.length ){
      
        for( const i in this.teachers ){

          const { id_teacher } = this.teachers[i]
              
          const existeBono = this.bonosTeachers.find( el => el.id_usuario == id_teacher )

          let totalBono = existeBono ? this.format( existeBono.monto ) : '$0.00'

          this.teachers[i]['bono_teacher'] = totalBono

        }

      }

    }catch( error ){

      console.log( error )

    }



    if( ![3,4].includes(this.opcionFiltro) ){


      if( this.opcionFiltro == 2 ){

            // return this.teachers.filter( el => el.estatus_quincena == 2 )
            // return this.teachers.filter( el => el.estatus_quincena == 2 || el.estatus_bono == 2 )
        return this.teachers.filter( el => el.estatus_sabatina == 2 )

      }else if( this.opcionFiltro == 1 ){

            // return this.teachers.filter( el => el.estatus_quincena == 1 && el.estatus_bono == 1 )
            // return this.teachers.filter( el => el.estatus_quincena == 1 && el.pago_quincena != '$0.00' )
        return this.teachers.filter( el => el.estatus_sabatina == 1 )

      }else{

            // return this.teachers.filter( el => el.estatus_quincena == 0  )
            // return this.teachers.filter( el => el.estatus_quincena == 0 || el.estatus_bono == 0 )
        return this.teachers.filter( el => el.estatus_sabatina == 0 )

      }

    }else{

      if( this.opcionFiltro == 3 ){

        return this.teachers

      }else{

        return this.teachers.filter( el => !el.existeCategoria )

      }

    }
  },


  tablaBonos( ){

      // Historial reconstruido (máximo de la semana = requi $29,700)
      if( Array.isArray(this.bonosHistorialActual) && this.bonosHistorialActual.length ){
        return this.bonosHistorialActual
      }

      // Fuente: asistencias_17-07.xlsx (PAGO Anterior / Comparativa Bonos)
      const bonosDesdeAsistencias = [
        { id_teacher: 23022, teacher: "MANUEL ALBERTO DAVILA GONZALEZ", monto: 350 },
        { id_teacher: 2181, teacher: "Lehi Benjamin Santana Paz", monto: 500 },
        { id_teacher: 1339, teacher: "ROBESPIERRE LANDA GUZMAN", monto: 500 },
        { id_teacher: 2835, teacher: "MARIA FERNANDA PEREZ TRUJILLO", monto: 350 },
        { id_teacher: 2820, teacher: "JESUS GUADALUPE HERNANDEZ CHIARIGLIONE", monto: 500 },
        { id_teacher: 2880, teacher: "ANGEL GUTIERREZ LUIS", monto: 350 },
        { id_teacher: 2856, teacher: "DIEGO ALEJANDRO RODRIGUEZ URIBE", monto: 350 },
        { id_teacher: 2813, teacher: "GLORIANNE RAMIREZ MORALES", monto: 350 },
        { id_teacher: 2800, teacher: "ESTEFANY ABIGAIL GARDUNO CRUCES", monto: 350 },
        { id_teacher: 2238, teacher: "ALAN EDUARDO PALACIOS TAMEZ", monto: 500 },
        { id_teacher: 1159, teacher: "JOSE BENJAMIN LOPEZ ECHAVARRIA", monto: 350 },
        { id_teacher: 2869, teacher: "CRISTOFER LEONARDO FRAUSTO ARAUJO", monto: 350 },
        { id_teacher: 2206, teacher: "WENDY ABIGAIL OBREGON ROCHA", monto: 350 },
        { id_teacher: 274, teacher: "Belen Erik Ovando Cruz", monto: 500 },
        { id_teacher: 2362, teacher: "FERNANDO FRANCISCO MENDIOLA AGUILLON", monto: 350 },
        { id_teacher: 1687, teacher: "Oscar Alberto Vargas Jiménez", monto: 350 },
        { id_teacher: 2076, teacher: "PEDRO EZEQUIEL RENTERIA MARTINEZ", monto: 500 },
        { id_teacher: 1103, teacher: "VERONICA XIADANY CUEVAS LICEA", monto: 500 },
        { id_teacher: 23032, teacher: "America Abigail Eguia Mancilla", monto: 500 },
        { id_teacher: 2013, teacher: "SERGIO JAVIER CADENA GOMEZ", monto: 500 },
        { id_teacher: 2360, teacher: "ANA CLAUDIA NUNEZ MENDOZA", monto: 500 },
        { id_teacher: 2003, teacher: "MELISSA MARIA SALINAS RAMIREZ", monto: 350 },
        { id_teacher: 2308, teacher: "DEYRA SHANDEL GUADIAN ALONZO", monto: 350 },
        { id_teacher: 2639, teacher: "Axel Ricardo Schulz Rodriguez", monto: 350 },
        { id_teacher: 22957, teacher: "FRANCISCO ERNESTO FLORES MENDEZ", monto: 350 },
        { id_teacher: 2814, teacher: "DANIEL DOMINGUEZ ROGRIGUEZ", monto: 350 },
        { id_teacher: 2584, teacher: "Edgar Aguilar Campos", monto: 500 },
        { id_teacher: 1782, teacher: "Gabriela Rubio Campos", monto: 500 },
        { id_teacher: 825, teacher: "Itzel Estefania Martinez Nieto", monto: 350 },
        { id_teacher: 2674, teacher: "Stefanny Monserrat Gonzalez Correa", monto: 500 },
        { id_teacher: 2619, teacher: "Saul Villalobos Sanchez", monto: 350 },
        { id_teacher: 2392, teacher: "VALERIA GOVEA GARZA", monto: 350 },
        { id_teacher: 1938, teacher: "TATIANA ESCAMILLA ACOSTA", monto: 500 },
        { id_teacher: 23048, teacher: "LUIS ALEJANDRO HERNANDEZ RODRIGUEZ", monto: 350 },
        { id_teacher: 2500, teacher: "VANESSA IVONNE HERNANDEZ HERNANDEZ", monto: 350 },
        { id_teacher: 1992, teacher: "VANIA YAMILETH CEPEDA GUERRA", monto: 1000 },
        { id_teacher: 2380, teacher: "ROGELIO GARZA GOONZALEZ", monto: 350 },
        { id_teacher: 23050, teacher: "ALBERTO CRUZ VILLEGAS", monto: 350 },
        { id_teacher: 22916, teacher: "MARIA DEL ROCIO ZAMORA RODRIGUEZ", monto: 500 },
        { id_teacher: 23062, teacher: "JACOB MENDOZA LOPEZ", monto: 350 },
        { id_teacher: 22995, teacher: "ARIADNA ENID GONZALEZ SANTACRUZ", monto: 500 },
        { id_teacher: 2805, teacher: "ANDREA DANAE LOZOYA MALDONADO", monto: 500 },
        { id_teacher: 2047, teacher: "DANIELA VERA CHAVEZ", monto: 350 },
        { id_teacher: 581, teacher: "Génesis Rodríguez Burrola", monto: 350 },
        { id_teacher: 1564, teacher: "edson giovani lerma hernandez", monto: 350 },
        { id_teacher: 810, teacher: "Héctor Espino Portal", monto: 350 },
        { id_teacher: 532, teacher: "Frida Sophia Perez Trujillo", monto: 350 },
        { id_teacher: 2283, teacher: "ALDO ALEJANDRO BENITEZ FUENTES", monto: 350 },
        { id_teacher: 2026, teacher: "EDUARDO MIGUEL RODRIGUEZ OLMEDO", monto: 500 },
        { id_teacher: 1597, teacher: "samantha garza gonzalez", monto: 350 },
        { id_teacher: 23024, teacher: "GAEL ADRIAN DOMINGUEZ AVALOS", monto: 500 },
        { id_teacher: 1539, teacher: "GERARDO MARCELO ARIZPE ESTRADA", monto: 350 },
        { id_teacher: 1414, teacher: "daphne elizabeth aviles", monto: 350 },
        { id_teacher: 1830, teacher: "JIMENA VILLARREAL VILLARREAL", monto: 350 },
        { id_teacher: 2176, teacher: "RICARDO YAÑEZ MARTINEZ", monto: 350 },
        { id_teacher: 2348, teacher: "ISAEL EDUARDO GONZALEZ CRUZ", monto: 1000 },
        { id_teacher: 22978, teacher: "ALEJANDRO RODRIGUEZ MORENO", monto: 350 },
        { id_teacher: 2192, teacher: "FRANCISCO JAVIER CHAPA GARZA", monto: 500 },
        { id_teacher: 2018, teacher: "ALAN FERNANDO OBREGON ROCHA", monto: 350 },
        { id_teacher: 2454, teacher: "PEDRO ADRIAN LOZANO RODRIGUEZ", monto: 350 },
        { id_teacher: 866, teacher: "Veronica Yamiled Guerrero Sanchez", monto: 350 },
        { id_teacher: 2118, teacher: "Elsa Cecilia Ortega Gutierrez", monto: 500 },
        { id_teacher: 1629, teacher: "DANA CAMILA LOPEZ SALDAÑA", monto: 500 },
        { id_teacher: 23061, teacher: "MARIA FERNANDA ALVAREZ HERNANDEZ", monto: 350 },
        { id_teacher: 22930, teacher: "DIANA LAURA GALEANA FERNANDEZ", monto: 350 },
        { id_teacher: 23033, teacher: "Sergio Adrian Montemayor Ayala", monto: 350 },
        { id_teacher: 1849, teacher: "SHECCID ALEJANDRA HURTADO AGUILAR", monto: 500 },
      ]

      const normalizarNombre = (nombre) => String(nombre || '')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toUpperCase()

      let bonos = this.teachers.filter( el => el.bono_teacher != "$0.00" )

      let bonos_anteriores = bonosDesdeAsistencias.map((el) => ({
        id_teacher: el.id_teacher,
        teacher: el.teacher,
        monto: this.format( el.monto ),
      }))

      const buscarAnterior = (teacher) => {
        const norm = normalizarNombre(teacher)
        return bonos_anteriores.find((el) => normalizarNombre(el.teacher) === norm)
      }

      for( const i in bonos ){

        const { id_teacher, bono_teacher, teacher } = bonos[i]

        const existeAnterior = buscarAnterior(teacher)

        let bono_anterior_monto = existeAnterior ? parseFloat( String(existeAnterior.monto).replace('$','').replace(',','') ) : 0

        bonos[i].bono_teacher = bono_teacher ? bono_teacher : this.format( 0 )

        let nuevo_monto = bono_teacher ? parseFloat( String(bono_teacher).replace('$','').replace(',','') ) : 0

        let diferencia = nuevo_monto - bono_anterior_monto

        bonos[i]['bono_anterior'] = existeAnterior ? existeAnterior.monto : this.format( 0 )
        bonos[i]['diferencia'] = this.format( diferencia )

      }

      for( const i in bonos_anteriores ){

        const { id_teacher, monto, teacher } = bonos_anteriores[i]

        let existeTeacher = bonos.find( el =>
          normalizarNombre(el.teacher) === normalizarNombre(teacher)
        )

        if( !existeTeacher ){
          // Intentar resolver id_usuario real por nombre en teachers cargados
          const enNomina = (this.teachers || []).find(el =>
            normalizarNombre(el.teacher) === normalizarNombre(teacher)
          )
          bonos.push({
            id_teacher: enNomina ? enNomina.id_teacher : id_teacher,
            teacher,
            bono_anterior      : monto,
            bono_teacher       : this.format( 0 ),
            diferencia         : this.format( 0 - parseFloat( String(monto).replace('$','').replace(',','') ) ),
          })
        }
      }

      bonos.push({
        id_teacher: 100000,
        teacher   : 'TOTAL',
        bono_anterior      : this.format( bonos.map(item => parseFloat( String(item.bono_anterior).replace('$','').replace(',','') ) || 0 ).reduce((prev, curr) => prev + curr, 0) ),
        bono_teacher       : this.format( bonos.map(item => parseFloat( String(item.bono_teacher).replace('$','').replace(',','') ) || 0 ).reduce((prev, curr) => prev + curr, 0) ),
        diferencia         : this.format( bonos.map(item => parseFloat( String(item.diferencia).replace('$','').replace(',','') ) || 0 ).reduce((prev, curr) => prev + curr, 0) ),
      })

      return  bonos
  }

},

watch: {

  async selectedHeaders( value, oldValue ){
    this.headersNomina = [
      { text: 'id'                    , value: 'id_teacher'      },
      { text: 'Teacher'               , value: 'teacher'         },  
      { text: 'Categoría'             , value: 'aceptado'        },  
      { text: 'HSBC'                  , value: 'hsbc'            },  
      { text: 'Plantel'               , value: 'plantel'         },  
      { text: 'existeCategoria'       , value: 'existeCategoria' },  
      { text: 'PAGO_SABADO'           , value: 'PAGO_SABADO'     },
      { text: 'PAGO_DOBLES_SABADO'    ,  value: 'PAGO_DOBLES_SABADO'        },  

    ]

    if( [1,3].includes( this.selectedHeaders ) ){
      this.headersNomina.push({
        text: 'PAGO QUINCENA', 
        value: 'pago_quincena',
        align: 'end'
      })
    }


    if( [1].includes( this.selectedHeaders ) ){
      this.headersNomina.push({
        text: 'PAGO BONO', 
        value: 'bono_teacher',
        align: 'end'
      })
    }

    if( value && oldValue != null && oldValue !== value && this.ciclo ){
      await this.actualizarNomina()
    }
  }

},

async created () {


  this.headersNomina = [
    { text: 'id'              , value: 'id_teacher'      },
    { text: 'Teacher'         , value: 'teacher'         },  
    { text: 'Categoría'       , value: 'aceptado'        },  
    { text: 'HSBC'            , value: 'hsbc'            },  
    { text: 'Plantel'         , value: 'plantel'         },  
    { text: 'existeCategoria' , value: 'existeCategoria' },  
    { text: 'PAGO_SABADO'     , value: 'PAGO_SABADO'     },  
    { text: 'PAGO_DOBLES_SABADO'     , value: 'PAGO_DOBLES_SABADO'     },  
    { text: 'PAGO_SABADO_TOTAL'     , value: 'PAGO_SABADO_TOTAL'     },  
  ]

  if( this.selectedHeaders == 1 ){
    this.headersNomina.push({
      text: 'PAGO QUINCENA', 
      value: 'pago_quincena',
      align: 'end'
    })

    this.headersNomina.push({
      text: 'PAGO BONO', 
      value: 'bono_teacher',
      align: 'end'
    })

    this.headersNomina.push({
      text: 'PAGO_DOBLES', 
      value: 'PAGO_DOBLES',
      align: 'end'
    })
  }

  if( this.selectedHeaders == 3 ){
    this.headersNomina.push({
      text: 'PAGO QUINCENA', 
      value: 'pago_quincena',
      align: 'end'
    })

    this.headersNomina.push({
      text: 'PAGO_DOBLES', 
      value: 'PAGO_DOBLES',
      align: 'end'
    })
  }

  

  this.headersNomina.push({
    text: 'REBAJES', 
    value: 'REBAJES',
    align: 'end'
  })

  // this.headersNomina.push({
  //   text: 'PAGO TOTAL Q', 
  //   value: 'total_final',
  //   align: 'end'
  // })
  
  // Depende de la semana, son los campos que se van a llenar o a agregar en los headers de la tabla 1

  await this.getTeachersSinCategoria( )
  await this.actualizarNomina()

},

methods:{

  async actualizarNomina( ){
    await this.inciarNominaSabtina()
    if( !this.ciclo ) return
    await this.cargarHuellasNomina()
  },

  subirRequisicion( ){
    if( this.huellasPendientesRevision ){
      return this.validarErrorDirecto('Revisa los teachers sin huella antes de subir la requisición')
    }
    this.crearRequi()
  },

  getTeachersSinCategoria( ){
    this.liberar = false
    this.$http.get('teachers.sin.categoria').then(response=>{

      this.liberar  = response.data.length > 0 ? false : true
      this.maestros = response.data.map(( registro ) => { return registro.nombre_completo })
    }).catch( error =>{
      this.validarError( error.response.data.message )
    }).finally( () => { this.cargar = false })  
  },

  verComentarios( comentarios, tipo_nomina , item ){
    this.renglonNomina = item
    this.comentarios = comentarios
    this.tipo_nomina = tipo_nomina
    this.dialogVerComentario = true
  },

  exportar( ){
    this.exportExcel( this.filterTeachers  , 'teachers')
  },

  verDesgloseGuardado( ){
    if (!this.ciclo || !this.ciclo.id_ciclo) {
      return this.validarErrorDirecto('Selecciona un ciclo por favor')
    }

    this.dialogDesglose = true
    this.desgloseHistorial = []
    this.searchDesglose = ''
    this.cargar = true

    const payload = {
      id_ciclo: this.ciclo.id_ciclo,
      semana: this.selectedHeaders,
    }

    this.$http.post('get.historial.nomina.teacher', payload).then((response) => {
      this.desgloseHistorial = mapDetalleHistorialRows(response.data.detalle)
    }).catch((error) => {
      const mensaje = error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'No se pudo cargar el desglose guardado'
      this.validarError(mensaje)
    }).finally(() => {
      this.cargar = false
    })
  },

  exportarDesgloseHistorial( ){
    this.exportExcel(this.desgloseHistorial, 'desglose_teachers_sem' + this.selectedHeaders)
  },

  responder ( ) {
    this.cargar = true
    const payload = {
      id_usuario : this.getdatosUsuarioERPERP.iderp,  
      id_teacher : this.renglonNomina.id_teacher,  
      estatus    : [334,966].includes( this.getdatosUsuarioERPERP.iderp ) ? 0 : 2,
      id_ciclo   : this.ciclo.id_ciclo,
      semana     : this.selectedHeaders,
      motivo     : this.respuesta,
      tipo_nomina: this.tipo_nomina,
    }

    this.$http.post('teachers.estatus.responder', payload).then(response=>{
      this.validarSuccess('Datos grabados correctamente')
      this.respuesta    = ''
      this.dialogVerComentario = false
      this.cargar       = false
      this.initialize()
    }).catch( error =>{
      this.validarError( error.response.data.message )
    }).finally( () => { this.cargar = false })  
  },

  format( valor ){
    valor = valor ? valor : 0
    return valor.toLocaleString('es-MX', {
      style: 'currency',
      currency: 'MXN'
    })
  }
}
}
</script>




